import React from 'react';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import Logo from '@/components/Logo';

function Team({ visitor, team }) {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
  return (
    <Grid container alignItems="center" justify={visitor ? "flex-end" : 'flex-start'}>
      <Grid item xs={12} md={6}>
        <Logo size={isMobile ? undefined : 20 } id={team.id} />
      </Grid>
    </Grid>
  )
}

export default Team;
